/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-06-15 14:57:17
 * @LastEditors: Luke Z
 * @LastEditTime: 2021-06-15 15:05:46
 * @FilePath: /unifyxp-v2-store-portal/src/constrains/DraggableModules/ContentGroup/ModulesGenerator/ProductCarousel.ts
 */
import { ActionType } from 'src/types/common/common';

import {
  //ProductList,
  //   LongCanvas,
  //   Text,
  //   Poster,
  //   ProductGridDisplay,
  CarouselAdaptor,
  //   ListAdaptor,
} from 'src/constrains/DraggableModules/Components';

const ProductCarouselFunctions = ({
  onDynamicChange,
  onStaticChange,
  onModuleTypeChange,
}) => {
  const handleOnProductCarouselItemReselect = (id, products) => {
    if (onDynamicChange) {
      onDynamicChange({ type: ActionType.reselect, id, data: products });
    }
  };

  const handleOnProductCarouselItemDelete = (id, index) => {
    if (onDynamicChange) {
      onDynamicChange({ type: ActionType.delete, id, data: { index } });
    }
  };

  const handleOnProductCarouselItemSort = (id, from, to) => {
    if (onDynamicChange) {
      onDynamicChange({
        type: ActionType.reorder,
        id,
        data: { from, to },
      });
    }
  };

  const handleOnProductCarouselItemDeleteAll = (id) => {
    if (onDynamicChange) {
      onDynamicChange({
        type: ActionType.deleteAll,
        id,
        data: [],
      });
    }
  };

  const handleOnProductCarouselStaticChange = (id, data) => {
    if (onStaticChange) {
      onStaticChange({
        type: ActionType.modify,
        id,
        data,
      });
    }
  };

  const handleOnCarouselModuleTypeChange = (data) => {
    if (onModuleTypeChange) {
      onModuleTypeChange(data);
    }
  };

  return {
    handleOnProductCarouselItemReselect,
    handleOnProductCarouselItemDelete,
    handleOnProductCarouselItemSort,
    handleOnProductCarouselItemDeleteAll,
    handleOnProductCarouselStaticChange,
    handleOnCarouselModuleTypeChange,
  };
};
const generateProductCarousel = ({
  onDynamicChange,
  onStaticChange,
  onModuleTypeChange,
  allDisabled,
}) => {
  const {
    handleOnProductCarouselItemReselect,
    handleOnProductCarouselItemDelete,
    handleOnProductCarouselItemSort,
    handleOnProductCarouselItemDeleteAll,
    handleOnProductCarouselStaticChange,
    handleOnCarouselModuleTypeChange,
  } = ProductCarouselFunctions({
    onDynamicChange,
    onStaticChange,
    onModuleTypeChange,
  });
  return {
    component: CarouselAdaptor,
    props: {
      onItemReselect: handleOnProductCarouselItemReselect,
      onItemDelete: handleOnProductCarouselItemDelete,
      onItemSort: handleOnProductCarouselItemSort,
      onItemDeleteAll: handleOnProductCarouselItemDeleteAll,
      onStaticChange: handleOnProductCarouselStaticChange,
      onModuleTypeChange: handleOnCarouselModuleTypeChange,
      allDisabled,
    },
  };
};
export { generateProductCarousel };
